/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsPatient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function IsPatient({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/IsPatient"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let relationshipFromPersonRecordPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'relationship',
path: 'from_person_record.patient._id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(relationshipFromPersonRecordPatientIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}